type TBreakpoints = {
  [name: string]: string
  sm: string
  md: string
  lg: string
  xl: string
  xxl: string
  xxxl: string
  xxll: string
}

export const widths = {
  xs: 320,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
  xxll: 1920,
}

export const breakpoints: TBreakpoints = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
  xxxl: '1600px',
  xxll: '1920px',
}
export const device = {
  mobile: `(min-width: ${breakpoints.sm})`,
  tablet: `(min-width: ${breakpoints.md})`,
  desktopLG: `(min-width: ${breakpoints.lg})`,
  desktopXL: `(min-width: ${breakpoints.xl})`,
  desktopXXL: `(min-width: ${breakpoints.xxl})`,
  desktopXXXL: `(min-width: ${breakpoints.xxxl})`,
  desktopXXLL: `(min-width: ${breakpoints.xxll})`,
}

export default breakpoints
